import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import { StaticImage } from 'gatsby-plugin-image';

import './style.scss';

const MapSection = () => {
  return (
    <section className="l-map-feature">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
      </Parallax>

      <div className="container">
        <h2 className="section-title">Associations with approved professional standards schemes</h2>
        <div className="map" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
          <StaticImage
            src="./assets/map-logos.png"
            alt="Map of Australia featuring the brands of the Professional Standards Scheme Associations Network"
            quality={100}
            width={740}
          />
          <div className="sr-only">
            Associations with schemes:
            <ul>
              <li>Australian Computer Society</li>
              <li>Association of Consulting Surveyors National</li>
              <li>Australian Property Institute Valuers Limited</li>
              <li>Bar Association of Queensland</li>
              <li>Chartered Accountants Australia and New Zealand</li>
              <li>Certified Practising Accountant Australia Limited</li>
              <li>Institute of Public Accountants</li>
              <li>Law Institute of Victoria</li>
              <li>The Law Society of New South Wales</li>
              <li>The Law Society of South Australia</li>
              <li>The Law Society of Western Australia</li>
              <li>New South Wales Bar Association</li>
              <li>Queensland Law Society</li>
              <li>Royal Institution of Chartered Surveyors Valuers Ltd</li>
              <li>South Australian Bar Association</li>
              <li>Victorian Bar Association</li>
              <li>Western Australian Bar Association</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
